module.exports = __webpack_public_path__ + "img/img6.a0d6a298.png";